import { ModelType } from '@livv/models';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, List, ListItem, SxProps, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { InternalDocumentLink } from '@components/Links';
import { ModelTypeLogo } from '@components/search';
import { useBookPageContext } from '@utils/context/book';

interface DecisionsCitationsProps {
    sx?: SxProps;
}

const DecisionsCitations: FC<DecisionsCitationsProps> = ({ sx }) => {
    const { decisionsCitationsInPublicationSheet } = useBookPageContext();
    const { t } = useTranslation('books');

    if (
        !decisionsCitationsInPublicationSheet ||
        decisionsCitationsInPublicationSheet.length === 0
    ) {
        return null;
    }

    return (
        <Box data-test-id="decisions-citations" sx={sx}>
            <ModelTypeLogo modelType={ModelType.DECISION} sx={{ mb: 3 }} />
            <Typography mb={3} variant="h2">
                {t('citations.decisions')}
            </Typography>
            <List disablePadding>
                {decisionsCitationsInPublicationSheet.map(({ decisionId, key, title }) => (
                    <ListItem key={key} disableGutters>
                        <Box alignItems="center" display="flex">
                            <InternalDocumentLink
                                docId={decisionId}
                                sx={{
                                    '&&': {
                                        alignItems: 'center',
                                        color: 'grey.100',
                                        display: 'flex',
                                    },
                                }}
                                hideTooltip
                                openInNewTab
                            >
                                {title}
                                <OpenInNewIcon fontSize="small" sx={{ color: 'grey.100', ml: 1 }} />
                            </InternalDocumentLink>
                        </Box>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default DecisionsCitations;
